import { pageLayout_children, bigScreen_pageLayout_children, app_pageLayout_children } from "./menus/index"
const cxPageLayout = {
  name: "cx",
  desc: "布局组件",
  render: () => import("./render/index.vue"),
  optDes: null,
  enable: true,
  menus: {
    app: [
      {
        name: "布局",
        children: app_pageLayout_children
      }
    ],
    bigScreen: [
      {
        name: "布局",
        children: bigScreen_pageLayout_children
      }
    ],
    portal: [
      {
        name: "布局",
        children: pageLayout_children
      }
    ]
  },
  toolbars: [
    {
      setting: () => import("./toolbars/pageLayout-options-setting.vue")
    }
  ]
}

export default cxPageLayout
